<p-table #table
    [value]="timelines" 
    responsiveLayout="stack" 
    [breakpoint]="'960px'"
    styleClass="p-datatable-striped" 
    [paginator]="true" 
    [showCurrentPageReport]="true" 
    [rowHover]="true" 
    showGridlines
    [globalFilterFields]="['titolo']" 
    currentPageReportTemplate="{first} di {last} su {totalRecords} timeline" 
    [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]">
    <ng-template pTemplate="caption">
        <div class="flex lg:flex-row flex-col gap-4 w-full">
            <div class="lg:w-3/4 w-full">
                <span class="block w-full p-input-icon-left">
                    <i class="bi bi-search before:align-super before:content-['\f52a']"></i>
                    <input pInputText type="text" (input)="onGlobalFilter(table, $event)" placeholder="Cerca..." class="w-full indent-6" />
                </span>
            </div>
            <div class="lg:w-1/4 w-full">                    
                <button class="w-full h-full btn-outln-backoffice text-center" type="button" (click)="add = true">                
                    <i class="bi bi-plus"></i>
                    Aggiungi timeline
                </button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>       
            <th class="w-1/12"></th>     
            <th class="w-9/12">Titolo</th>
            <th class="w-2/12"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-timeline let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td class="text-center">
                <i class="bi bi-list text-4xl hover:text-black" pReorderableRowHandle></i>
            </td>
            <td>{{timeline.titolo || '-'}}</td>
            <td class="text-center">
                <div class="flex flex-row items-center justify-center">
                    <a [href]="timeline.immagine ? (timeline.immagine + '?type=image' | file) : (timeline.pdf | pdf)" target="_blank">
                        <i class="bi text-2xl hover:text-black cursor-pointer" [ngClass]="{'bi-card-image': timeline.immagine, 'bi-file-pdf': timeline.pdf}"></i>
                    </a>
                    <p-divider layout="vertical"></p-divider>
                    <i class="bi bi-pencil text-2xl hover:text-black cursor-pointer" (click)="onOpenEdit(timeline)"></i>
                    <p-divider layout="vertical"></p-divider>
                    <ng-container *ngIf="timeline.id">
                        <p-confirmPopup #deleteTimeline>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <p-button class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()" label="Elimina" />
                                        <p-button class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnullaDelete()" label="Annulla" />
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash text-2xl hover:text-black cursor-pointer" (click)="onOpenDelete($event, timeline, index)"></i>    
                    </ng-container>
                    <ng-container *ngIf="!timeline.id">
                        <i class="bi bi-trash text-2xl hover:text-black cursor-pointer" (click)="timelines.splice(index, 1)"></i>
                    </ng-container>
                    
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="3">Nessun dato presente nella timeline.</td>
        </tr>
    </ng-template>
</p-table>

<!-- MODAL ADD/EDIT TIMELINE -->
<p-dialog [visible]="(add || edit)" [style]="{width: '75%'}" [header]="add ? 'Aggiungi timeline' : 'Modifica timeline'" [modal]="true" class="p-fluid" (visibleChange)="onCloseModal();">
    <ng-template pTemplate="content">

        <form [formGroup]="formTimeline" (ngSubmit)="add ? onAdd() : onEdit()">
            <div class="flex flex-col gap-8">                
                <div class="flex lg:flex-row flex-col gap-8">
                    <div class="lg:w-1/2 w-full">
                        <label>* Titolo</label>
                        <input type="text" pInputText formControlName="titolo" />
                    </div>
                    <div class="lg:w-1/2 w-full">
                        <label>* Data</label>
                        <p-calendar formControlName="data" dateFormat="dd/mm/yy" appendTo="body" [showIcon]="true" />
                    </div> 
                </div>            
                <div class="w-full">
                    <label>Descrizione</label>
                    <p-editor [style]="{ height: '150px' }" formControlName="descrizione" />
                </div>
                <div class="flex lg:flex-row flex-col gap-8" *ngIf="add">
                    <div class="lg:w-1/2 w-full">
                        <label>Immagine</label>
                        <p-fileUpload mode="advanced" [disabled]="!show_pdf" [pTooltip]="!show_pdf ? 'Un pdf è stato caricato nella timeline, se si vuole mostrare le immagini o caricare un pdf diverso rimuovere quello caricato!' : ''" tooltipPosition="top" [multiple]="false" chooseLabel="Seleziona un'immagine" accept="image/*" maxFileSize="1000000000" cancelLabel="Rimuovi" [showUploadButton]="false" (onSelect)="onImmagineUpload($event)" (onRemove)="onRemoveImmagineUpload($event)" (onClear)="onRemoveImmagineUpload($event)" />
                    </div>

                    <div class="lg:w-1/2 w-full">
                        <label>PDF</label>
                        <p-fileUpload mode="advanced" [disabled]="!show_pdf" [pTooltip]="!show_pdf ? 'Un pdf è stato caricato nella timeline, se si vuole mostrare le immagini o caricare un pdf diverso rimuovere quello caricato!' : ''" tooltipPosition="top" [multiple]="false" chooseLabel="Seleziona un PDF" accept="application/pdf" maxFileSize="1000000000" cancelLabel="Rimuovi" [showUploadButton]="false" (onSelect)="onPDFUpload($event)" (onRemove)="onRemovePDFUpload($event)" (onClear)="onRemovePDFUpload($event)" />
                    </div>
                </div>
                <div class="w-full flex lg:flex-row flex-col gap-4 justify-end">
                    <button type="submit" class="btn-outln-backoffice py-[0.75rem] px-8 font-medium" [disabled]="!formTimeline.valid">{{add ? 'Aggiungi' : 'Modifica'}}</button>
                    <button type="button" class="btn-danger-backoffice py-[0.75rem] px-8 font-medium" (click)="onCloseModal()">Annulla</button>
                </div>
            </div>
        </form>
    </ng-template>
</p-dialog>
<!-- MODAL ADD/EDIT TIMELINE -->